// extracted by mini-css-extract-plugin
module.exports = {"container":"SideBarFilters_container__30-tj","section":"SideBarFilters_section__yE_UQ"};